import { useContext } from 'react';
import { Layout, PrivateLayoutContext } from 'context';

const usePrivateLayout = (): Layout => useContext(PrivateLayoutContext);

export default usePrivateLayout;
